import { z } from 'zod';
import {
  amountSchema,
  currencyCodeSchema,
  cursorQuerySchema,
  imagePathsSchema,
  tradeDirectionSchema,
  uuidSchema,
} from './common';

export const createRequestSchema = z.object({
  direction: tradeDirectionSchema,
  categoryId: uuidSchema.optional(),
  title: z.string().min(2).max(120),
  description: z.string().max(4000).optional(),
  city: z.string().max(80).optional(),
  budgetAmount: amountSchema,
  budgetCurrency: currencyCodeSchema,
  quantity: z.number().int().min(1).max(999).default(1),
  images: imagePathsSchema.default([]),
});
export type CreateRequestInput = z.infer<typeof createRequestSchema>;

export const updateRequestSchema = createRequestSchema.partial();
export type UpdateRequestInput = z.infer<typeof updateRequestSchema>;

export const listRequestsQuerySchema = cursorQuerySchema.extend({
  q: z.string().max(100).optional(),
  direction: tradeDirectionSchema.optional(),
  categoryId: uuidSchema.optional(),
  status: z.enum(['open', 'matched', 'completed', 'cancelled', 'expired']).optional(),
});
export type ListRequestsQuery = z.infer<typeof listRequestsQuerySchema>;

export const createOfferSchema = z.object({
  priceAmount: amountSchema,
  currency: currencyCodeSchema,
  message: z.string().max(1000).optional(),
  etaDays: z.number().int().min(1).max(60).optional(),
});
export type CreateOfferInput = z.infer<typeof createOfferSchema>;
